import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { WINDOW } from '@grid-ui/common';
import { isNullOrUndefined } from '@maplecroft-typescript/utils';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';

@Injectable()
export class SvgService {
  private svgIds: { [key: string]: string } = {};
  private svgCache = new Map<string, Observable<SafeHtml>>();

  constructor(
    @Inject(WINDOW) private readonly window: Window | any,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
  ) {
    if (this.window instanceof Window) {
      // Find all svg loaded on the page and create hash map
      const symbolSvgSprite: NodeListOf<SVGSymbolElement> = this.window.document.querySelectorAll('symbol');
      const svgIds: SVGSymbolElement[] = Array.prototype.slice.call(symbolSvgSprite);
      this.svgIds = svgIds.reduce((acc, item: SVGSymbolElement) => ({ ...acc, ...{ [item.id]: `#${item.id}` } }), {});
    }
  }

  public getNavigationIcon(svgId: string): string {
    const defaultImage = '#shape-verisk';
    return `${this.svgIds[svgId] || defaultImage}`;
  }

  public getExtSvg(url: string): Observable<SafeHtml> {
    if (!this.svgCache.has(url)) {
      const svg$ = this.http.get<string>(url, { responseType: 'text' as 'json' }).pipe(
        catchError(() => of('')),
        map((svgString) => {
          const svgDoc = new DOMParser().parseFromString(svgString, 'image/svg+xml');
          const svg = svgDoc.querySelector<SVGElement>('svg');

          if (isNullOrUndefined(svg)) {
            return '';
          }

          svg.removeAttribute('width');
          svg.removeAttribute('height');

          const elementsToRemove: Element['tagName'][] = ['defs', 'title', 'style', 'desc'];

          elementsToRemove.forEach((elementTag) => Array.from(svgDoc.querySelectorAll(elementTag)).forEach((element) => element.remove()));

          const attributesToRemove = ['fill', 'id', 'data-name', 'class', 'stroke'];

          attributesToRemove.forEach((attribute) =>
            Array.from(svgDoc.querySelectorAll(`[${attribute}]`)).forEach((element) => element.removeAttribute(attribute)),
          );

          return this.sanitizer.bypassSecurityTrustHtml(svg.outerHTML);
        }),
        shareReplay(1),
      );
      this.svgCache.set(url, svg$);
    }
    return this.svgCache.get(url);
  }
}
